import React, { useState } from 'react'
import { FiMenu } from 'react-icons/fi'
import { CgClose } from 'react-icons/cg'
import { SlSocialLinkedin } from 'react-icons/sl'
import { BsDribbble } from 'react-icons/bs'
import { FiGithub } from 'react-icons/fi'
import logoImg from '../assets/logo.png'

const Navbar = () => {
  const [nav, setNav] = useState(false)
  const handleClick = () => setNav(!nav)
  return (
    <div className="fixed w-full h-[80px] flex justify-between items-center p-16 bg-[#fffbf3]">
      <div>
        <a href="/" className="flex justify-between items-center">
          <img
            src={logoImg}
            alt="cute duck"
            style={{ width: '60px' }}
            className="mx-4"
          />
          REBECCA LIANG
        </a>
      </div>

      {/* menu */}

      <ul className="hidden md:flex ">
        <li>
          <a href="/">Home</a>
        </li>
        <li>
          <a href="/work">Projects</a>
        </li>
        <li>
          <a href="/about">About</a>
        </li>
        <li>
          <a
            href="/"
            className="bg-[#907aff] text-white px-4 py-2 rounded-md font-bold hover:bg-[#56a2fa] hover:text-white"
          >
            Resume
          </a>
        </li>
      </ul>

      {/* hambuger */}
      <div onClick={handleClick} className="md:hidden z-10">
        {!nav ? <FiMenu /> : <CgClose />}
      </div>

      {/* mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#fffbf3] flex flex-col justify-center items-center '
        }
      >
        <li className="py-6 text-4xl">
          <a href="/">Home</a>
        </li>
        <li className="py-6 text-4xl">
          <a href="/work">Projects</a>
        </li>
        <li className="py-6 text-4xl">
          <a href="/about">About</a>
        </li>
        <li className="py-6">
          <a
            href="/"
            className="bg-[#907aff] text-white px-4 py-2 rounded-md font-bold hover:bg-[#56a2fa] hover:text-white text-4xl"
          >
            Resume
          </a>
        </li>
      </ul>

      {/* social icons */}
      <div className="hidden xl:flex fixed flex-col top-[35%] left-0 pl-8">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center duration-300 mb-12">
            <a
              className="flex justify-between items-center w-full"
              href="https://www.linkedin.com/in/rebecca-l-626185130/"
              target="_blank"
              rel="noreferrer"
            >
              <SlSocialLinkedin size={20} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center duration-300 mb-12">
            <a
              className="flex justify-between items-center w-full"
              href="/"
              target="_blank"
              rel="noreferrer"
            >
              <BsDribbble size={20} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center duration-300">
            <a
              className="flex justify-between items-center w-full"
              href="https://github.com/yingerliang"
              target="_blank"
              rel="noreferrer"
            >
              <FiGithub size={20} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Navbar
